import styled from "@emotion/styled";
import { SMALL_DEVICES } from "../mediaQueries";

export const Button = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px 25px;
  border-radius: 15px;
  border: 3px solid #e77134;
  background-color: #e77134;
  color: white;
  cursor: pointer;
  text-style: none;

  &.inverted {
    background-color: black;
    color: #e77134;
  }

  ${SMALL_DEVICES} {
    padding: 2vw 5vw;
  }
`;
